// Popup logic
$('[data-selector-id="forms-root-553949"]').on('click', function(e){
  e.preventDefault();
  $('[data-forms-id="forms-root-553949"]').slideDown();
  $('.close-popup').fadeIn();
});

$('.close-popup').on('click', function(e){
  e.preventDefault();
  $('.close-popup').fadeOut();
  $('[data-forms-id="forms-root-553949"]').slideUp();
});

// Video: single-click play, native pause
document.addEventListener("DOMContentLoaded", function () {
  const vids = document.querySelectorAll(".product-single__media-native-video video");

  vids.forEach(function (vid) {
    // make the video look clickable
    vid.style.cursor = "pointer";

    vid.addEventListener("click", function (e) {
      // Only hijack FIRST click to guarantee instant play
      if (!vid.dataset.activated) {
        e.preventDefault();
        e.stopPropagation();

        if (vid.paused) {
          vid.play();
        }

        // Mark activated so all future interactions are native
        vid.dataset.activated = "1";
      }
    });
  });
});
document.addEventListener('mousedown', function (e) {
  const bar = e.target.closest('.thb-global-notification, .thb-global-notification-link');
  if (!bar) return;

  if (e.target.closest('.thb-notification-close')) return;

  e.preventDefault();        // ← THIS WAS MISSING
  e.stopPropagation();       // ← THIS TOO

  const btn = document.querySelector('.button_pop_trigger[data-pop-trigger="popup"]');
  if (btn) btn.click();
});
document.addEventListener("click", function () {
  setTimeout(function () {
    var closeBtn = document.querySelector(".mfp-close");
    if (closeBtn) {
      closeBtn.textContent = "Close";
    }
  }, 50);
});